import { Modal } from "flowbite-react";
import { useToastContext } from "../../../../common/components/ui/toast/toast.context";
import { useEffect, useState } from "react";
import Loading from "../../../../common/components/ui/loading/Loading";
import { getLeadById, updateLeadCommercialActions } from "../../../../common/services/leads.api";
import { ILead } from "../../../../types/lead.type";
import FormLeadCommecialActions from "../forms/FormLeadCommecialActions";

type Props = {
  data: { auth: string, leadId: string }
  onClose: () => void
}


export default function CommercialActionsLeads(props: Props) {
  const leadId = props.data.leadId
  const [leadData, setLeadData] = useState<ILead | null>(null);
  const { notifySuccess, notifyError } = useToastContext();

  useEffect(() => {
    async function loadLeadData(leadId: string) {
      if (!leadId) return;

      const { data, ok } = await getLeadById(leadId);

      if (ok) {
        setLeadData(data as ILead);
      }
    }

    setLeadData(null);

    if (leadId) loadLeadData(leadId);
  }, [leadId]);

  async function saveLead(dataToSave: Partial<ILead>) {
    try {
      const response = await updateLeadCommercialActions(leadId as string, dataToSave)

      const { ok, data, errors } = response;
      if (ok && data) {
        setLeadData(data as ILead)
        notifySuccess(`Cliente "${leadData?.name}" atualizado!`)
        return { ok, data: data as ILead, errors: (errors as [{ message: string, path: string[] }]) }
      }

      if (!ok) {
        notifyError(response.message as string)
      }

      return { ok, data: data as ILead, errors: errors as [{ message: string, path: string[] }] }
    } catch (err) {
      console.log(err)
      notifyError('Erro ao tentar salvar cliente, tente novamente')
      return {
        ok: false,
        data: dataToSave,
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        errors: [{ message: (err as any).message, path: [] }]
      }
    }
  }


  const handleCloseModal = () => { props.onClose() }
  return (
    <Modal
      size={'3xl'}
      className='relative'
      show={true}
      onClose={() => handleCloseModal()}
    >
      <Modal.Header className="dark:text-black">
        <span className="dark:text-black">{`Ações comerciais: ${leadData?.name}`}</span>
      </Modal.Header>
      <Modal.Body className="dark:text-black">
        {leadData ? (
          <FormLeadCommecialActions
            onSubmit={saveLead}
            data={leadData!}
          />
        ) : <Loading />}
      </Modal.Body>
      <Modal.Footer>
      </Modal.Footer>
    </Modal>
  )
}